"use strict";import{tag as a}from"./custom-tag.js";export{setCustomTemplateLiteralTag}from"./custom-tag.js";export const DefaultIcon=({width:e=24,height:l=24,hidden:t=!1,title:r="Default"}={})=>a`
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            role="img"
            fill="currentColor"
            width=${e}
            height=${l}
            aria-hidden=${t?"true":"false"}
            aria-label=${t?void 0:r}
        >
            <path
                d="m10,18.75c-4.82471,0-8.75-3.9248-8.75-8.75S5.17529,1.25,10,1.25s8.75,3.9248,8.75,8.75-3.92529,8.75-8.75,8.75Zm0-16c-3.99756,0-7.25,3.25195-7.25,7.25s3.25244,7.25,7.25,7.25,7.25-3.25195,7.25-7.25-3.25244-7.25-7.25-7.25Z"
                fill="currentColor"
                stroke-width="0"
            ></path>
        </svg>
    `;
//# sourceMappingURL=DefaultIcon.js.map
